















import { defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useOnUserLogin from "@/hooks/useOnUserLogin";
import providers from "@/lib/api";
import { OlecamsLiveRoom } from "@/types/olecams";
import useStreamLogger from "../../hooks/useStreamLogger";
import StreamView from "../StreamView/StreamView.vue";

export default defineComponent({
  name: "ConsumeController",
  components: { StreamView },
  props: {
    producer: { type: Object as () => UserPublicData },
    roomId: { type: String, required: true },
  },
  setup(props) {
    const videoFrameBaseUrl = "https://brokers.videochatprovider.com/player/v2/video/?sessionToken=";
    const chatFrameBaseUrl = "https://brokers.videochatprovider.com/player/v2/chat/?sessionToken=";

    const { authUser } = useAuthUser();
    const { businessLogicLog } = useStreamLogger("[CONSUME CONTROLLER]", () => ({}));

    const consumeUser = ref({ id: "", username: "" });
    const liveRoom = ref<OlecamsLiveRoom | null>(null);
    const sessionToken = ref("");
    const loading = ref(false);
    const videoFrameUrl = ref("");
    const chatFrameUrl = ref("");

    const setConsumerUser = async () => {
      if (!authUser.value) {
        const guestId = Math.random()
          .toString()
          .substring(2, 10);
        consumeUser.value.id = guestId;
        consumeUser.value.username = "guest_user_" + guestId;
      } else {
        const response = await providers.OlecamsProvider.userSearch({ data: { userIds: [authUser.value.id] } });
        consumeUser.value.id = response[0]?.externalId ?? authUser.value.id;
        consumeUser.value.username = authUser.value.screenName
          ? authUser.value.screenName.replaceAll(/\W+/g, "_")
          : authUser.value.username.replaceAll(/\W+/g, "_");
      }
    };

    const onLiveRoomUpdate = (data: Partial<OlecamsLiveRoom>) => {
      if (!liveRoom.value) return;
      liveRoom.value = { ...liveRoom.value, ...data };
    };

    const getData = async () => {
      try {
        loading.value = true;
        await setConsumerUser();
        //TODO: create API for get room by userID
        const liveRooms = await providers.OlecamsProvider.getAllRooms();
        liveRoom.value = liveRooms.find(room => String(room.id) === props.roomId);
        // eslint-disable-next-line no-console
        console.debug({ ...liveRoom.value });
        if (!liveRoom.value) {
          console.error("Test Live room not found");
          return;
        }
        sessionToken.value = await providers.OlecamsProvider.getJoinToken({
          roomName: liveRoom.value.roomName,
          mode: liveRoom.value.roomMode,
          modelId: String(liveRoom.value.id),
          userId: consumeUser.value.id,
          userToken: consumeUser.value.id,
          userNick: consumeUser.value.username,
          userLang: "en",
        });

        videoFrameUrl.value = videoFrameBaseUrl + sessionToken.value;
        chatFrameUrl.value = chatFrameBaseUrl + sessionToken.value;
        businessLogicLog("Session token obtained and URLs set");
      } finally {
        loading.value = false;
      }
    };

    getData();
    useOnUserLogin(getData);

    return {
      liveRoom,
      loading,
      videoFrameUrl,
      chatFrameUrl,
      sessionToken,
      consumeUser,
      onLiveRoomUpdate,
      getData,
    };
  },
});
